'use client'

import {observer} from 'mobx-react'
import React, {useContext, useEffect, useMemo} from 'react'

import {getInjection} from '@runlab/di'

import type {FavouriteStoreInterface} from '@/src/presentation/stores/favourite/favourite.store.interface'

const FavouriteContext = React.createContext<Nullable<FavouriteStoreInterface>>(null)

export const FavouriteProvider = observer(({children}: React.PropsWithChildren) => {
  const favouriteStore = useMemo(() => getInjection('FavouriteStoreInterface'), [])

  useEffect(() => {
    favouriteStore.load()
  }, [favouriteStore])

  return <FavouriteContext.Provider value={favouriteStore}>{children}</FavouriteContext.Provider>
})

export const useFavourite = (): FavouriteStoreInterface => {
  const favouriteStore = useContext(FavouriteContext)

  if (!favouriteStore) throw new Error('useFavourite() must be used within FavouriteProvider')

  return favouriteStore
}
